import script from "./Startup.layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Startup.layout.vue?vue&type=script&setup=true&lang=js"

import "./Startup.layout.vue?vue&type=style&index=0&id=26dbb32a&lang=scss"

const __exports__ = script;

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QFooter});
